import React, { useState } from 'react';
import I18n from 'utils/I18n';
import Button from '@strava/ui/Button';
import clsx from '@strava/ui/clsx';
import Spinner from '@strava/ui/Spinner';
import VisuallyHidden from '@strava/ui/VisuallyHidden';
import { trackV2 } from 'utils/analytics';

import { useCheckoutContext } from '../../../../state/CheckoutContext';
import { postCheckPromoCode } from '../../../../state/Checkout.actions';

import styles from './PromoCodeInput.scss';

const PromoCodeInput = () => {
  const { checkoutEntityState, dispatch } = useCheckoutContext();
  const {
    analyticsData,
    checkoutSubmitting,
    promoCodeSubmitting,
    promoCodeError,
    isTrial,
    packageIds,
    duration
  } = checkoutEntityState;

  const [promoCode, setPromoCode] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    trackV2({
      category: 'checkout',
      page: 'cart',
      action: 'click',
      element: 'promo_code_submit',
      properties: {
        ...analyticsData,
        subscription_type: isTrial ? 'trial' : 'organic'
      }
    });

    const formData = {
      code: promoCode,
      packageIds,
      recurring: duration
    };

    postCheckPromoCode(formData, dispatch);
  };

  return (
    <div className={styles.promoCodeContainer}>
      <form
        className={styles.form}
        onSubmit={handleSubmit}
        data-testid="promo-code-form"
      >
        <div
          className={clsx(
            'form-group',
            styles.promoCodeInput,
            promoCodeError ? 'has-error' : ''
          )}
          data-testid="promo-code-div"
        >
          <VisuallyHidden>
            <label htmlFor="promo-code">
              {I18n.t(
                'strava.subscriptions.checkout.summary.organic.promo_code.label'
              )}
            </label>
          </VisuallyHidden>
          <input
            id="promo-code"
            data-testid="promo-code-input"
            className={clsx('form-control', styles.formControl)}
            type="text"
            autoComplete="off"
            autoFocus={true}
            disabled={checkoutSubmitting || promoCodeSubmitting}
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
          />
          <Button
            type="submit"
            variant="default"
            data-testid="btn-apply"
            className={styles.btnApply}
            disabled={checkoutSubmitting || promoCodeSubmitting}
          >
            {promoCodeSubmitting ? (
              <Spinner />
            ) : (
              I18n.t(
                'strava.subscriptions.checkout.summary.organic.promo_code.cta.apply'
              )
            )}
          </Button>
        </div>
      </form>
      {promoCodeError && (
        <div className={styles.errorMessage}>
          {I18n.t(
            'strava.subscriptions.checkout.summary.organic.promo_code.error'
          )}
        </div>
      )}
    </div>
  );
};

export default PromoCodeInput;
